class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/* fatturazione*/
// Salva "Richiedo fattura" come cart attribute dal mini-carrello
document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.querySelector('#invoice-request');
  if (!checkbox) return;

  async function saveInvoiceAttribute(checked) {
    const body = {
      attributes: {
        'Richiedo fattura': checked ? 'Sì' : ''
      }
    };
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      // (Facoltativo) Trigghera un refresh del drawer se il tema lo supporta
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch(e) {
      console.error('Errore salvataggio attributo fattura:', e);
    }
  }

  checkbox.addEventListener('change', (e) => {
    saveInvoiceAttribute(e.target.checked);
  });
});

// toggle dati fatturazione

document.addEventListener('DOMContentLoaded', () => {
  const chk = document.querySelector('#invoice-request');
  const panel = document.querySelector('#invoice-fields');
  const saveBtn = document.querySelector('#invoice-save');
  const msg = document.querySelector('#invoice-msg');
  const form = document.querySelector('#invoice-form');

  const saveAttributes = async (obj) => {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json','Accept':'application/json' },
      body: JSON.stringify({ attributes: obj })
    });
  };

  const toggle = async () => {
    if (!chk) return;
    if (chk.checked) {
      panel.removeAttribute('hidden');
      await saveAttributes({ 'Richiedo fattura':'Sì' });
    } else {
      panel.setAttribute('hidden','');
      await saveAttributes({
        'Richiedo fattura':'',
        'Ragione sociale':'','P.IVA':'','Codice Fiscale':'','SDI/PEC':''
      });
    }
  };
  chk && chk.addEventListener('change', toggle);

  // Salva tutto con un click
  saveBtn && saveBtn.addEventListener('click', async () => {
    const data = Object.fromEntries(new FormData(form).entries());
    // validazione minima facoltativa
    if (chk.checked && (!data['Ragione sociale'] || !(data['P.IVA'] || data['Codice Fiscale']))) {
      msg.textContent = 'Compila Ragione sociale e P.IVA o Codice Fiscale.'; return;
    }
    const mapped = {};
    Object.keys(data).forEach(k => mapped[k] = data[k]);
    await saveAttributes(mapped);
    msg.textContent = 'Dati salvati ✅';
    setTimeout(() => msg.textContent = '', 2000);
  });

  // init
  toggle();
});


document.addEventListener('DOMContentLoaded', () => {
  const chk   = document.querySelector('#cart-invoice-request');
  const panel = document.querySelector('#cart-invoice-fields');
  const form  = document.querySelector('#cart-invoice-form');
  const save  = document.querySelector('#cart-invoice-save');
  const msg   = document.querySelector('#cart-invoice-msg');
  const checkoutBtn = document.querySelector('button[name="checkout"], button[type="submit"][form]');

  const saveAttributes = (obj) =>
    fetch('/cart/update.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json','Accept':'application/json' },
      body: JSON.stringify({ attributes: obj })
    });

  const toggle = async () => {
    if (!chk) return;
    if (chk.checked) {
      panel.removeAttribute('hidden');
      await saveAttributes({ 'Richiedo fattura':'Sì' });
    } else {
      panel.setAttribute('hidden','');
      await saveAttributes({
        'Richiedo fattura':'',
        'Ragione sociale':'','P.IVA':'','Codice Fiscale':'','SDI/PEC':''
      });
    }
  };
  if (chk) chk.addEventListener('change', toggle);

  // Salva tutti i campi con il pulsante "Salva dati"
  if (save && form) {
    save.addEventListener('click', async () => {
      const data = Object.fromEntries(new FormData(form).entries());
      // validazione minima: se fattura richiesta -> Ragione + (P.IVA o CF)
      if (chk && chk.checked && (!data['Ragione sociale'] || !(data['P.IVA'] || data['Codice Fiscale']))) {
        msg.textContent = 'Compila Ragione sociale e P.IVA o Codice Fiscale.'; return;
      }
      await saveAttributes(data);
      msg.textContent = 'Dati salvati ✅';
      setTimeout(()=> msg.textContent = '', 2000);
    });
  }

  // Salva su blur (facoltativo)
  document.querySelectorAll('#cart-invoice-fields input[type="text"]').forEach(inp => {
    inp.addEventListener('blur', () => {
      const key = inp.name; // es. "P.IVA"
      saveAttributes({ [key]: inp.value });
    });
  });

  // (Opzionale) blocca il checkout se selezionata fattura ma mancano i campi
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async (e) => {
      if (chk && chk.checked) {
        const rag = document.querySelector('#cart-ragione')?.value.trim();
        const piva = document.querySelector('#cart-piva')?.value.trim();
        const cf   = document.querySelector('#cart-cf')?.value.trim();
        if (!rag || (!piva && !cf)) {
          e.preventDefault();
          msg.textContent = 'Per proseguire: Ragione sociale e P.IVA o Codice Fiscale.';
          // salvataggio parziale per non perdere inserimenti
          await saveAttributes({
            'Ragione sociale': rag || '',
            'P.IVA': piva || '',
            'Codice Fiscale': cf || ''
          });
          return false;
        }
      }
    });
  }

  // init
  toggle();
});
